import { Config } from '../services/config/config.service';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class CampaignsClient {
  private endpoint: string;

  constructor(private http: HttpClient, _config: Config) {
    this.endpoint = _config.CONFIG.apiUrl + '/campaigns';
  }

  get(): Observable<any> {
    return this.http.get(this.endpoint).pipe(
      catchError(err => throwError(err))
    );
  }

  optIn(campaignId: any): Observable<any> {
    const params = new HttpParams().set('campaign_id', campaignId);
    return this.http.post(`${this.endpoint}/${campaignId}/opt_in`, {}, { params }).pipe(
      catchError(err => throwError(err))
    );
  }

  optInBonusCode(bonusCode: any): Observable<any> {
    return this.http.post(`${this.endpoint}/bonus_code`, { bonus_code: bonusCode }).pipe(
      catchError(err => throwError(err))
    );
  }

  verifyCampaign(bonusCode: string): Observable<any> {
    return this.http.get(`${this.endpoint}/bonus_code_status/${bonusCode}`, { withCredentials: true }).pipe(
      catchError(err => throwError(err))
    );
  }
}
